import React, {useRef, useState} from "react";
import {
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  OutlinedInput,
  Tooltip,
  Autocomplete,
  Box,
  Typography,
  Checkbox,
  InputAdornment,
  IconButton,
  TableRow,
  TableCell,
  Divider,
} from "@mui/material";
import "./LabelValueDisplay.css";
import InfoIcon from '../../../../../asset/image/new_Info_Icon.svg';
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import { CheckBox, Visibility, VisibilityOff } from "@mui/icons-material"; 
import calender_icon from '../../../../../asset/image/calender_icon.svg';
import calender_time_icon from '../../../../../asset/image/calender_time_icon.svg';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker, DateTimePicker } from "@mui/x-date-pickers";
import moment, {Moment } from "moment-timezone";

// import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

interface LabelValueDisplayProps {
  label: string;
  value?: string | any;
  valueType?: "default" | "status" | "syncStatus";
  isInput?: boolean;
  isDropdown?: boolean;
  dropdownOptions?: string[];
  disabledOptions?: string[];
  tooltipMapping?: [];
  placeholder?: string;
  lastSeen?: string;
  onChange?: (
    e: React.ChangeEvent<HTMLInputElement> | SelectChangeEvent
  ) => void;
  error?: string;
  type?: string;
  disabled?: boolean;
  customComponent?: React.ReactNode;
  infoText?: string;
  paddingLeft?: number;
  show?: boolean;
  labelType?: string;
  isAutoComplete?: boolean;
  options?: any;
  optionKey?: string;
  Value?: any;
  handleChange?: (event: any, newValue: any) => void;
  editableText?: boolean;
  isEditing?: boolean;
  editableTextChanged?: boolean;
  onEditClick?: () => void;
  onEditableTextChange?: (e: any) => void;
  handleEditableTextSave?: () => void;
  handleEditClose?: () => void;
  width?: number;
  maxWidth?: string;
  icon?: any;
  flexDirection?: string;
  isMultiValue?: boolean;
  multiValues?: string[];
  isBoxText?: boolean;
  boxWidth?: number;
  isPassword?: boolean;
  passwordClass?: boolean;
  isCheckBox?: boolean;
  isChecked?: boolean;
  handleCheckBoxClick?: () => void;
  isDate?: boolean;
  isTime?: boolean;
  isDateTime?: boolean;
  isCurrentDateTime?: boolean;
  timeZone?: string;
  validTimeZone?: string;
  selectedDateTime?: any;
  setSelectedDateTime?: any;
  selectedDate?: any;
  isMultiline?: boolean;
  textInputRows?: number;
  allowListSelection?: boolean;
  scanList?: any;
  readOnly?: boolean;
  onFocus?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  isMonthYear?: boolean;
  minDate?: any;
  maxDate?: any;
  isHtml?: boolean;
}

const LabelValueDisplay: React.FC<LabelValueDisplayProps> = ({
  label,
  value = "",
  valueType = "default",
  isInput = false,
  isDropdown = false,
  dropdownOptions = [],
  disabledOptions = [],
  tooltipMapping = [],
  placeholder = "",
  onChange,
  error,
  type,
  disabled,
  lastSeen,
  customComponent,
  infoText = '',
  paddingLeft = 0,
  show = true,
  labelType,
  isAutoComplete = false,
  options=[],
  optionKey, 
  Value,
  handleChange,
  editableText,
  isEditing,
  editableTextChanged,
  onEditClick,
  onEditableTextChange,
  handleEditableTextSave,
  handleEditClose,
  width=0,
  maxWidth,
  isDate = false,
  isTime = false,
  isDateTime = false,
  isCurrentDateTime = false,
  timeZone,
  validTimeZone,
  selectedDateTime,
  setSelectedDateTime,
  selectedDate,
  icon,
  flexDirection,
  isMultiValue,
  multiValues,
  isBoxText,
  boxWidth,
  isPassword,
  passwordClass,
  isCheckBox=false,
  isChecked,
  handleCheckBoxClick,
  isMultiline,
  textInputRows,
  allowListSelection,
  scanList,
  readOnly,
  onFocus,
  isMonthYear=false,
  minDate,
  maxDate,
  isHtml
}) => {

  const baseColor = value ? "#000" : "#D0D1DC";
  const dateInputRef = useRef<HTMLInputElement | null>(null);
  const [time24, setTime24] = useState(() => {
    const now = new Date();
    return `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;
  });
  const [showPassword, setShowPassword] = useState(false);
  const [openTime, setOpenTime] = useState(false);
  const [openDate, setOpenDate] = useState(false);
  const [openDateTime, setOpenDateTime] = useState(false);

  const [openMonthDate, setOpenMonthDate] = useState(false);

  const getNow = (): Moment => {
    return moment.tz(validTimeZone?? "UTC");
  };

  if (!show) return null;
  const sharedInputStyles = {
    width: "100%",
    height: "28px",
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "10px",
    color: baseColor,
    "& .MuiOutlinedInput-root": {
      height: isMultiline ? "auto" : "28px",
      borderRadius: "4px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: "4px !important",
    },
    "& .MuiSelect-select": {
      display: "flex",
      alignItems: "center",
      padding: "0px 10px",
      height: "28px",
      fontSize: "12px",
      color: baseColor,
      border: "1px solid #EBEBEB",
    },
    "& .MuiOutlinedInput-input": {
      // padding: "0px 10px !important",
      height: "28px",
      fontSize: "12px",
      fontFamily: "Inter",
      fontWeight: 500,
      color: baseColor,
      maxWidth: '100%',
      "&::placeholder": {
        color: "#D0D1DC",
        opacity: 1,
      },
    },
  };

  const renderValueComponent = () => {
    if (customComponent) return customComponent;
    if(isCheckBox) return null;
    if(isBoxText) return(
      <div style={{width:`${boxWidth}px`}} className="boxText">
        {value}
      </div>
    )
    if(isPassword) return(
      <div style={{width:`${boxWidth}px`}} className={passwordClass ? "boxText-2" : "boxText"}>
        <input
            className={passwordClass ? "passwordClass" : ""}
            type={showPassword ? "text" : "password"}
            value={value}
            onChange={onChange as React.ChangeEventHandler<HTMLInputElement>} // 🔹 Add callback to update state
            style={{
              flex: 1,
              border: "none",
              outline: "none",
              background: "transparent",
              fontSize: "12px",
              overflow: "hidden",
              padding: "0px",
              width: `${boxWidth? boxWidth-20 : 120}px`
            }}
            placeholder={placeholder || ""}
            disabled={disabled}
        />
        <div
          style={{ cursor: disabled ? "not-allowed" : "pointer", marginLeft: "auto", opacity: disabled ? 0.5 : 1}}
          onClick={() => { 
            if (disabled) return;
            setShowPassword(!showPassword)}
          }>
            {!showPassword ? <VisibilityOff fontSize="small" sx={{ color: passwordClass ? '#6B7280' : '' }} /> : <Visibility fontSize="small" sx={{ color: passwordClass ? '#6B7280' : '' }} />}
        </div>
      </div>
    )
    if(isMultiValue) return(
      multiValues?.map((value)=>{
        return(<div className="value-text">{value??""}</div>)
      })
    )

    if(allowListSelection){
      return(
        <TableRow
          hover
          // onClick={() => setMccMnc(item)}   // clicking row fills text field
        >
          {scanList.map((item:any)=>(
            <TableCell style={{display:"table-row-group"}}>{item}</TableCell>
          ))}
          
        </TableRow>
      )
    }
  // Format value to browser-supported yyyy-MM-dd
  const getFormattedDate = (dateStr?: string) => {
    const date = dateStr ? new Date(dateStr) : new Date();
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const formattedValue = value ? getFormattedDate(value) : getFormattedDate();

    if(isAutoComplete){
      return(
        <Autocomplete
            options={options}
            getOptionLabel={(option:any) => option[`${optionKey}`]}
            isOptionEqualToValue={(option, value) =>
              option?.[`${optionKey}`] === value?.[`${optionKey}`]
            }
            value={Value || null}
            onChange={(event, newValue:any) => {
                handleChange?.(event, newValue);
            }}
            getOptionDisabled={(option: any) => option?.disabled || false}
            renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              size="small"
              placeholder={placeholder}
              className="commonAutoComplete"
              sx={{
                // Border
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#ccc', // change border color
                },
                // On focus
                '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#2F4B82',
                },
                // Input text
                '& input': {
                  padding: 0,
                },
              }}
            />
          )}
          sx={{
            minWidth: 200,
            width: "100%",
            // Optional overall styling
            '& .MuiAutocomplete-inputRoot': {
              padding: 0,
            },
          }} 
        />
      )
    }

    if(editableText){
      return(
        <div style={{width: "100%"}}>
        {!isEditing ? (
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    borderRadius: "8px",
                    padding: "6px 10px 6px 0px",
                }}
            >
            <Typography
                sx={{ fontWeight: 500, flex: 1, fontSize: "14px", color: "#0F172A" }}
            >
                {value}
            </Typography>

            <EditIcon
                onClick={onEditClick}
                style={{
                    width: 16,
                    height: 16,
                    cursor: "pointer",
                    marginLeft: 8,
                    color: "#6B7280",
                }}
            />
            </Box>)
          : 
            (
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #D1D5DB",
                    borderRadius: "4px",
                    padding: "6px 10px",
                    backgroundColor: "#fff",
                }}
            >
                <input
                    type="text"
                    value={value}
                    autoFocus
                    onChange={(e) => {
                      onEditableTextChange?.(e)
                    }}
                style={{
                    flex: 1,
                    border: "none",
                    outline: "none",
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#0F172A",
                }}
                />

                {/* Save (✔) */}
                <CheckIcon
                onClick={handleEditableTextSave}
                style={{
                    width: 18,
                    height: 18,
                    cursor: editableTextChanged ? "pointer" : "not-allowed",
                    color: editableTextChanged ? "#6B7280" : "#D1D5DB",
                    marginLeft: 8,
                    pointerEvents: editableTextChanged ? "auto" : "none",
                }}
                />

                {/* Cancel (✖) */}
                <CloseIcon
                    onClick={ handleEditClose}
                    style={{
                        width: 18,
                        height: 18,
                        cursor: "pointer",
                        color: "#6B7280",
                        marginLeft: 6,
                    }}
                />
            </Box>
            )
        }
      </div>)
    }

    if (isDropdown) {
      return (
        <Select
          MenuProps={{
            PaperProps: {
              sx: {
                mt: "2px",
                maxHeight: 240,
              },
              className: 'disable-scrollbar',
            },
            MenuListProps: {
              sx: {
                p: 0,
              },
            },
          }}
          value={value}
          onChange={onChange}
          displayEmpty
          size="small"
          input={<OutlinedInput notched={false} />}
          sx={sharedInputStyles}
          disabled={disabled}
          renderValue={(selected) =>
            selected ? (
              <Tooltip title={selected}>
                <span
                  style={{ maxWidth: maxWidth ? maxWidth : 'unset' }}
                  className="labelValueDisaplay-ellipsis"
                >
                  {selected}
                </span>
              </Tooltip>
            ) : (
              <span style={{ color: "#D0D1DC" }}>{placeholder}</span>
            )
          }
        >
          <MenuItem value="" disabled hidden style={{ fontSize: '13px', fontFamily: 'Inter' }}>
            {placeholder}
          </MenuItem>
          {dropdownOptions.map((option, idx) => {
            if (option === "DIVIDER") {
              return <Divider key={`divider-${idx}`} sx={{ my: 0.5 }} />;
            }
            return(
             
                <MenuItem 
                  key={idx} 
                  value={option} 
                  disabled={disabledOptions.includes(option)}
                  sx={{ lineHeight: 'unset', fontSize: '13px', fontFamily: 'Inter' }}>
                     <Tooltip title={tooltipMapping? tooltipMapping[option]: ""}>
                        <span style={{width:"100%"}}>{option}</span>
                      </Tooltip>
                </MenuItem>
              )
      })}
        </Select>
      );
    }

    if (isInput) {
      return (
        <TextField
          type={type}
          value={value}
          onChange={onChange as React.ChangeEventHandler<HTMLInputElement>}
          placeholder={placeholder}
          variant="outlined"
          size="small"
          sx={sharedInputStyles}
          InputProps={{ readOnly:readOnly, notched: false }}
          disabled={disabled}
          multiline={isMultiline}
          rows={textInputRows}
          onFocus={onFocus}
        />
      );
    }

if (valueType === "status" && labelType != 'konnectStatusWithTitle' && value) {
  const { color, boxShadow } = getKonnectStatusColor(value);

  const statusComponent = (
    <div
      className="status-value"
      style={{
        cursor: "pointer", // Always show pointer on hover
      }}
    >
      <span
        className="status-dot"
        style={{ backgroundColor: color, boxShadow }}
      />
      <span className="status-text">{value}</span>
    </div>
  );

  // Only wrap in Tooltip if lastSeen is non-empty
  if (lastSeen && lastSeen.trim() !== "") {
    return (
      <Tooltip title={`Last seen: ${lastSeen}`} arrow>
        <span>{statusComponent}</span>
      </Tooltip>
    );
  }
  return statusComponent;
}

    if (valueType === "status" && labelType == 'konnectStatusWithTitle' && value) {
      const statusComponent = (
        <div
          className="status-value"
          style={{
            cursor: "pointer",
          }}
        >
        </div>
      );
      return statusComponent;
    }

    if (valueType === "syncStatus" && value) {
      const statusComponent = (
        <div className="sync-status">
          <span className="status-text">{value}</span>
        </div>
      );
      return statusComponent;
    }

    if (isDate) {
      // Convert value to moment object for AdapterMoment compatibility
      const today = moment();
      const formattedValue = value ? moment(value) : today;
      
      // Convert minDate and maxDate to moment objects if they exist
      const momentMinDate = minDate ? moment(minDate) : undefined;
      const momentMaxDate = maxDate ? moment(maxDate) : undefined;
      
      return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DatePicker
            open={openDate && !disabled}
            onOpen={() => { if (!disabled) setOpenDate(true); }}
            onClose={() => setOpenDate(false)}
            value={formattedValue}
            timezone={validTimeZone}
            onChange={(newValue) => {
              if (!newValue) return;
              // Convert moment back to Date object for onChange handler
              const dateValue = moment.isMoment(newValue) ? newValue.toDate() : newValue;
              onChange?.({ target: { value: dateValue } } as any);
            }}
            minDate={momentMinDate}
            maxDate={momentMaxDate}
            disablePast
            slotProps={{
              textField: {
                id: "date-input",
                variant: "outlined",
                size: "small",
                sx: sharedInputStyles,
                InputProps: {
                  notched: false,
                  sx: {
                    "& input": {
                      padding: "6px 8px",
                      width: "100%",
                      "&::-webkit-calendar-picker-indicator": { display: "none" },
                      "&::-webkit-inner-spin-button": { display: "none" },
                      "&::-webkit-clear-button": { display: "none" },
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "6px 8px",
                      maxWidth: "100%",
                    },
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        edge="end"
                        disabled={disabled}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (disabled) return;
                          setOpenDate(true);
                        }}
                      >
                        <img src={calender_icon} alt="calendar" style={{ opacity: disabled ? 0.5 : 1, cursor: disabled ? 'not-allowed' : 'pointer' }} />
                      </IconButton>
                    </InputAdornment>
                  ),
                },
                disabled,
              },
            }}
          />
        </LocalizationProvider>
      );
    }

    if (isTime) {
      const now = new Date();

      const [mm, dd, yyyy] = selectedDate.split("-");
      const normalizedDateStr = `${yyyy}-${mm}-${dd}`;
      const selectedDateObj = new Date(normalizedDateStr);

      const todayStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
      const selectedDateStr = `${selectedDateObj.getFullYear()}-${String(selectedDateObj.getMonth() + 1).padStart(2, "0")}-${String(selectedDateObj.getDate()).padStart(2, "0")}`;

      const minTime = selectedDateStr === todayStr
        ? now
        : new Date(selectedDateObj.setHours(0, 0, 0, 0));

      return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <TimePicker
            ampm={false}
            open={openTime}
            onOpen={() => setOpenTime(true)}
            onClose={() => setOpenTime(false)}
            value={value ? new Date(`${normalizedDateStr}T${value}`) : now}
            minTime={minTime}
            onChange={(newValue) => {
              if (!newValue) return;
              const hours = String(newValue.getHours()).padStart(2, "0");
              const minutes = String(newValue.getMinutes()).padStart(2, "0");
              const formatted = `${hours}:${minutes}`;
              setTime24(formatted);
              onChange?.({ target: { value: formatted } } as any);
            }}
            slotProps={{
              textField: {
                variant: "outlined",
                size: "small",
                sx: sharedInputStyles,
                InputProps: {
                  notched: false,
                  sx: {
                    "& input": {
                      padding: "6px 8px",
                      width: "100%",
                      "&::-webkit-calendar-picker-indicator": {
                        opacity: 0,
                        cursor: "pointer",
                        position: "absolute",
                        right: 0,
                      },
                      "&::-webkit-inner-spin-button": { display: "none" },
                      "&::-webkit-clear-button": { display: "none" },
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "6px 8px",
                      maxWidth: "100%",
                    },
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton edge="end" onClick={() => setOpenTime(true)}>
                        <img src={calender_time_icon} alt="clock" />
                      </IconButton>
                    </InputAdornment>
                  ),
                },
                inputProps: {
                  id: "time-input",
                  min: minTime,
                },
                disabled: disabled,
              },
            }}
          />
        </LocalizationProvider>
      );
    }

    if (isDateTime) {
      return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DateTimePicker
            ampm={false}
            disablePast
            open={openDateTime}
            closeOnSelect={false}
            onOpen={() => {
              if (selectedDateTime && moment.isMoment(selectedDateTime) && selectedDateTime.isBefore(getNow())) {
                setSelectedDateTime(getNow());
              }
              setOpenDateTime(true)
            }}
            onClose={() => setOpenDateTime(false)}
            value={selectedDateTime}
            onChange={(newValue) => {
              if (!newValue) return;

              const newMoment = moment.isMoment(newValue) ? newValue : moment(newValue);

              const now = getNow();
              const adjustedValue = newMoment.isBefore(now) ? now : newMoment;

              setSelectedDateTime(adjustedValue);
            }}
            slotProps={{
              textField: {
                id: "datetime-input",
                variant: "outlined",
                size: "small",
                sx: sharedInputStyles,
                InputProps: {
                  notched: false,
                  sx: {
                    "& input": {
                      padding: "6px 8px",
                      width: "100%",
                      "&::-webkit-calendar-picker-indicator": { display: "none" },
                      "&::-webkit-inner-spin-button": { display: "none" },
                      "&::-webkit-clear-button": { display: "none" },
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "6px 8px",
                      maxWidth: "100%",
                    },
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        edge="end"
                        onClick={(e) => {
                          e.stopPropagation();
                          setOpenDateTime(true);
                        }}
                      >
                        <img src={calender_icon} alt="calendar" />
                         <span style={{ marginLeft: 6, fontSize: 12 }}>
                          {timeZone}
                        </span>
                      </IconButton>
                    </InputAdornment>
                  ),
                },
                disabled,
              },
            }}
          />
        </LocalizationProvider>
      );
    }

    if (isCurrentDateTime) {
      return (
        <Box sx={{ position: "relative", width: "100%" }}>
          <TextField
            variant="outlined"
            size="small"
            value="Now"
            sx={{
              ...sharedInputStyles,
              "& .MuiOutlinedInput-input": {
                padding: "6px 8px",
                fontWeight: 500,
                fontFamily: 'Inter',
                fontSize: '14px',
                color: 'rgba(69, 70, 78, 1)'
              },
            }}
            InputProps={{
              readOnly: true,
              notched: false,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    edge="end"
                    onClick={(e) => {
                      e.stopPropagation();
                      setOpenDateTime(true);
                      onChange?.({
                        target: { value: "Schedule Update" },
                      } as any);
                    }}
                  >
                    <img src={calender_time_icon} alt="calendar" />
                     <span style={{ marginLeft: 6, fontSize: 12 }}>
                      {timeZone}
                    </span>
                  </IconButton>
                </InputAdornment>
              ),
            }}
            disabled={disabled}
          />
        </Box>
      );
    }

    if (isMonthYear) {

      return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            disabled={disabled}
            views={["year", "month"]}
            open={openMonthDate}
            onOpen={() => setOpenMonthDate(true)}
            onClose={() => setOpenMonthDate(false)}
            value={value}
            format="MM/yyyy"
            onChange={(newValue) => {
              onChange?.({
                target: { value: newValue },
              } as any);
            }}
            disablePast
            slotProps={{
              textField: {
                id: "month-year-input",
                variant: "outlined",
                size: "small",
                sx: sharedInputStyles,
                InputProps: {
                  notched: false,
                  sx: {
                    "& input": {
                      padding: "6px 8px",
                      width: "100%",
                      "&::-webkit-calendar-picker-indicator": { display: "none" },
                      "&::-webkit-inner-spin-button": { display: "none" },
                      "&::-webkit-clear-button": { display: "none" },
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "6px 8px",
                      maxWidth: "100%",
                    },
                    "& .MuiSvgIcon-root": {
                      height: "18px",
                    },
                  }
                },
                disabled,
              },
            }}
          />
        </LocalizationProvider>
      );
    }

    return icon ? 
      <div className="flex-dispaly-gap">
        <div className="value-text">{value || '- -'}</div>
        <img src={icon} alt="" className="icon" />
      </div>
      : isHtml ? <div className="value-text height-unset" dangerouslySetInnerHTML={{ __html: value || '- -' }}></div> 
      : <div className="value-text" style={{ height: flexDirection ? 'unset' : '28px' }}>{value || '- -'}</div>;;
  };
  const { color, boxShadow } = getKonnectStatusColor(value);

  return (
    <div className={flexDirection=='row' ? "label-value-container label-value-container-row" : "label-value-container"} style={{ paddingLeft: `${paddingLeft}px`, width:`${width > 0 ? `${width}px` : "none"}`}}>
      <div
        className="label-text"
        style={{
          color: disabled ? "rgba(204, 204, 204, 1)" : "#6E7079",
          display: "flex",
          alignItems: "center",
          gap: "4px",
          marginBottom: flexDirection ? 'unset' : '6px'
        }}
      >
        {isCheckBox && (
          <Checkbox
            checked={isChecked}            
            onChange={handleCheckBoxClick}
            disabled={disabled}     
            sx={{
              color: "#244c84",
              "&.Mui-checked": {
                color: "#244c84",
              },
              padding: "0px"
            }}
          />
        )}
        {valueType === "status" && labelType == 'konnectStatusWithTitle' && value && <span
          className="status-dot"
          style={{ backgroundColor: color, boxShadow }}
        />}
        {label}
        {infoText && (
          <Tooltip title={infoText}>
            <img src={InfoIcon} alt="info" style={(isInput || isDropdown || isAutoComplete) ? { marginTop: '-5px' } : {}} />
          </Tooltip>
        )}
      </div>
      {renderValueComponent()}
      {error && (
        <p style={{ color: "red", fontSize: "11px", marginTop: "5px" }}>{error}</p>
      )}
    </div>
  );
};

const getKonnectStatusColor = (status: string): { color: string; boxShadow?: string } => {
  const statusStyles: Record<string, { color: string; boxShadow?: string }> = {
    STATUS_CONNECTED: {
      color: "#1ED768",
      boxShadow: "0px 0px 6px 0px #c1f7dd",
    },
    Online: {
      color: "#1ED768",
      boxShadow: "0px 0px 6px 0px #c1f7dd",
    },
    STATUS_NOT_CONNECTED: {
      color: "red",
      boxShadow: "0px 0px 6px 0px red",
    },
    Offline: {
      color: "red",
      boxShadow: "0px 0px 6px 0px red",
    },
    Unknown: {
      color: "gray",
      boxShadow: "0px 0px 6px 0px gray",
    },
  };

  return statusStyles[status] || { color: "grey" };
};

export default LabelValueDisplay;
